var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13.3643mm",
    height: "13.031892mm",
    viewBox: "0 0 13.3643 13.031892",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-406.75148,-296.63923)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(1.6975572,0,0,1.6975572,-212.69053,-156.22253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5",
    transform: "translate(106.91081,51.776711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3-4-8",
    transform: "matrix(0.12706229,0,0,0.12706229,257.99119,214.99589)",
    style: {
      fill: "#642754",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1029-1-6",
    "data-name": "Tracciato 1029",
    d: "M 17.332,0 0.6,15.245 0,37.689 8.445,55.463 29.918,60.418 50.809,51.118 61.959,30.234 52.808,4.672 28.111,0.139 Z",
    fill: "#71ac9e",
    style: {
      fill: "#642754",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "UI_Select_arrow-8",
    d: "m 263.7511,218.86958 -2.16869,2.56046 0.38041,-1.9134 -1.93336,0.59179 0.14195,-2.26345 1.82702,0.28913 -0.16307,-1.77902 z",
    fill: "#59194b",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.128485
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaRight);
export default __webpack_public_path__ + "static/media/AreaRight.47784e9f9a46abea3c7056fdc79ca3af.svg";
export { ForwardRef as ReactComponent };